import { render, staticRenderFns } from "./NoteHistoryListComp.vue?vue&type=template&id=6e58d920&scoped=true"
import script from "./NoteHistoryListComp.vue?vue&type=script&lang=js"
export * from "./NoteHistoryListComp.vue?vue&type=script&lang=js"
import style0 from "./NoteHistoryListComp.vue?vue&type=style&index=0&id=6e58d920&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e58d920",
  null
  
)

export default component.exports